// extracted by mini-css-extract-plugin
export default {"cancelBtn":"RecoverAccountSecondStep_cancelBtn__taXTh","searchBtn":"RecoverAccountSecondStep_searchBtn__kUo-0"};